function staffUserLabel(user) {
  const display = String(user?.displayName || '').trim();
  if (display) return display;
  return String(user?.username || '').trim();
}

function isAssignableUser(user) {
  return Number(user?.assignable) === 1;
}

function sortStaffUsers(users, options = {}) {
  return (users || [])
    .filter((u) => staffUserLabel(u))
    .filter((u) => !options.assignableOnly || isAssignableUser(u))
    .slice()
    .sort((a, b) =>
      staffUserLabel(a).localeCompare(staffUserLabel(b), undefined, {
        sensitivity: 'base',
      }),
    );
}

function assignedToFooterLabel(order) {
  return String(order?.assignedToName || '').trim();
}

function assigneeFilterFromWorkOrder(order) {
  if (!order) return null;
  const assignedTo = Number(order.assignedTo);
  const name = assignedToFooterLabel(order);
  if (!(assignedTo > 0) && !name) return null;
  return {
    assignedTo: assignedTo > 0 ? assignedTo : null,
    name: name || 'Assigned',
  };
}

function reviewAssignedNameClick() {
  return 'pick-filter';
}

function reviewAssigneePickerId(order, filter) {
  const orderId = Number(order?.assignedTo);
  if (orderId > 0) return orderId;
  const filterId = Number(filter?.assignedTo);
  return filterId > 0 ? filterId : null;
}

function assigneeFilterFromStaffUser(user) {
  const assignedTo = Number(user?.id);
  const name = staffUserLabel(user);
  if (!(assignedTo > 0) || !name) return null;
  return { assignedTo, name };
}

function workOrderMatchesReviewAssignee(wo, assignee) {
  if (!wo || !assignee) return false;
  const filterId = Number(assignee.assignedTo);
  const woId = Number(wo.assignedTo);
  if (filterId && woId && filterId === woId) return true;
  const filterName = String(assignee.name || '')
    .trim()
    .toLowerCase();
  const woName = String(wo.assignedToName || '')
    .trim()
    .toLowerCase();
  return !!(filterName && woName && filterName === woName);
}

module.exports = {
  staffUserLabel,
  isAssignableUser,
  sortStaffUsers,
  assignedToFooterLabel,
  assigneeFilterFromWorkOrder,
  reviewAssignedNameClick,
  reviewAssigneePickerId,
  assigneeFilterFromStaffUser,
  workOrderMatchesReviewAssignee,
};


